export default __webpack_public_path__ + "static/media/logo.2cf24227.png";